import CloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import type React from 'react';
import { GLASS_BACKGROUND, GLASS_BLUR, NAVY, RADIUS_COIN, SHADOW, SURFACE_CONTAINER_LOW } from 'styles/tokens';

interface ProposalPdfDialogProps {
  open: boolean;
  onClose: () => void;
  url: string;
}

const ProposalPdfDialog: React.FC<ProposalPdfDialogProps> = ({ open, onClose, url }) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="lg"
    fullWidth
    slotProps={{
      paper: {
        sx: {
          borderRadius: RADIUS_COIN,
          backgroundColor: GLASS_BACKGROUND,
          backdropFilter: GLASS_BLUR,
          boxShadow: SHADOW,
        },
      },
    }}
  >
    <DialogTitle
      sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', color: NAVY, fontWeight: 600 }}
    >
      Propuesta
      <IconButton
        onClick={onClose}
        size="small"
        sx={{
          color: NAVY,
          backgroundColor: SURFACE_CONTAINER_LOW,
          borderRadius: RADIUS_COIN,
          '&:hover': { backgroundColor: '#eceaff' },
        }}
      >
        <CloseIcon />
      </IconButton>
    </DialogTitle>
    <DialogContent sx={{ p: 0 }}>
      <Box component="iframe" src={url} sx={{ width: '100%', height: '80vh', border: 'none' }} title="Propuesta PDF" />
    </DialogContent>
  </Dialog>
);

export default ProposalPdfDialog;
